import { css } from 'styled-components';

import { gstarColors } from './BaseStyledColorScheme';

/**
 * Shared reset for the underline/link button variants: strips the
 * box styling (border, background, padding, min-sizes) from
 * .contentBlock-body-link so only the text remains.
 */
const buttonVariantReset = css`
  --contentBlock-button-background-color: transparent;
  --contentBlock-button-hover-background-color: transparent;
  --contentBlock-button-active-background-color: transparent;

  min-width: 0;
  min-height: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  background-color: transparent;

  :where(.contentBlock-body-link-label) {
    min-width: 0;
  }
`;

/**
 * Solid button look: re-fills the background OUTLINE clears by default.
 * Shared by the contentBlock--buttonSolid / [data-button-type="solid"]
 * variant and the single-button [data-button-solid="1|2"] override.
 */
export const solidButtonVariant = css`
  ${({ theme }) => css`
    /* only read by brands whose contentBlockBodyLink uses it (AAF) */
    --contentBlock-button-font-weight: ${({ theme }) => theme.variables.font.weight.bold};
    --contentBlock-button-border-color: var(
      --contentBlock-buttonSolid-border-color,
      ${theme.colors.neutral['800']}
    );
    --contentBlock-button-background-color: var(
      --contentBlock-buttonSolid-background-color,
      ${theme.colors.neutral['800']}
    );
    --contentBlock-button-text-color: var(
      --contentBlock-buttonSolid-text-color,
      ${theme.colors.neutral['0']}
    );

    @media (hover: hover) {
      &:hover,
      &:focus {
        --contentBlock-button-border-color: var(
          --contentBlock-buttonSolid-hover-border-color,
          ${theme.colors.slate['600']}
        );
        --contentBlock-button-background-color: var(
          --contentBlock-buttonSolid-hover-background-color,
          ${theme.colors.slate['600']}
        );
        --contentBlock-button-text-color: var(
          --contentBlock-buttonSolid-hover-text-color,
          ${theme.colors.neutral['0']}
        );
      }
    }

    &:active {
      --contentBlock-button-border-color: var(
        --contentBlock-buttonSolid-active-border-color,
        ${theme.colors.slate['900']}
      );
      --contentBlock-button-background-color: var(
        --contentBlock-buttonSolid-active-background-color,
        ${theme.colors.slate['900']}
      );
      --contentBlock-button-text-color: var(
        --contentBlock-buttonSolid-active-text-color,
        ${theme.colors.neutral['0']}
      );
    }
  `}
`;

/**
 * Text-only ink: shared by underline and link, the two variants that never
 * fill a background — only --contentBlock-button-text-color moves.
 */
export const textButtonVariant = css`
  ${({ theme }) => css`
    ${buttonVariantReset}
    --contentBlock-button-text-color: var(--contentBlock-buttonText-color, ${gstarColors.slate[
      '900'
    ]});

    padding-block: ${theme.spacing.x['2xs']};

    @media (hover: hover) {
      &:hover,
      &:focus {
        --contentBlock-button-text-color: var(
          --contentBlock-buttonText-hover-color,
          ${gstarColors.slate['600']}
        );
      }
    }

    &:active {
      --contentBlock-button-text-color: var(
        --contentBlock-buttonText-active-color,
        ${gstarColors.slate['900']}
      );
    }
  `}
`;
